// 9fbef606107a605d69c0edbcd8029e5d
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import { sortLabels } from './Sort.labels';

const getSortOptions = ({ sortByRatingLabel } = {}) => {
  const sortLabelsNew = getLabelFromCopyOrFromTranslation('global.Sorting', sortLabels);
  let ratingsLabel;
  if (sortByRatingLabel) {
    ratingsLabel = sortByRatingLabel;
  } else {
    ratingsLabel = 'TCPBazaarVoiceRating desc';
  }
  return [
    { displayName: sortLabelsNew.lbl_recommended, id: '', isSelected: false }, // Default, no sort param required.
    {
      displayName: sortLabelsNew.lbl_min_offer_price_desc,
      id: 'min_offer_price desc',
      isSelected: false,
    },
    {
      displayName: sortLabelsNew.lbl_min_offer_price_asc,
      id: 'min_offer_price asc',
      isSelected: false,
    },
    { displayName: sortLabelsNew.lbl_newest_score, id: 'newest_score desc', isSelected: false },
    { displayName: sortLabelsNew.lbl_favoritedcount, id: 'favoritedcount desc', isSelected: false },
    {
      displayName: sortLabelsNew.lbl_TCPBazaarVoiceRating,
      id: ratingsLabel,
      isSelected: false,
    },
  ];
};

export default getSortOptions;
